<template>
  <div>
    <div class="coupon-list-window" :class="value === true ? 'on' : ''">
      <div class="title">
        优惠券
        <span class="iconfont icon-guanbi" @click="close"></span>
      </div>
      <div v-if="couponList.length > 0">
        <div class="coupon-list">
          <div
            class="item acea-row row-center-wrapper"
            v-for="coupon in couponList"
            :key="coupon.id"
            @click="click(coupon)"
          >
            <div class="money">
              <div>
                ￥<span class="num">{{ coupon.couponPrice }}</span>
              </div>
              <div class="pic-num">满{{ coupon.useMinPrice }}元可用</div>
            </div>
            <div class="text">
              <div class="condition line1">{{ coupon.couponTitle }}</div>
              <div class="data acea-row row-between-wrapper">
                <div v-if="coupon.endTime === 0">不限时</div>
                <div v-else>截止:{{ coupon.endTime }}</div>
                <div
                  class="iconfont icon-xuanzhong1 font-color-theme"
                  v-if="checked === coupon.id"
                ></div>
                <div class="iconfont icon-weixuanzhong" v-else></div>
              </div>
            </div>
          </div>
        </div>
        <div class="couponNo bg-color-theme" @click="couponNo">
          不使用优惠券
        </div>
      </div>
      <div v-if="!couponList.length && loaded">
        <div class="pictrue">
          <img src="@assets/images/noCoupon.png" class="image" />
        </div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      :hidden="value === false"
      @click="close"
    ></div>
  </div>
</template>
<style scoped>
.coupon-list {
  padding-top: 0.2rem;
}
.coupon-list-window .iconfont {
  font-size: 0.4rem;
}
.couponNo {
  font-size: 0.3rem;
  font-weight: bold;
  color: #fff;
  width: 6.9rem;
  height: 0.86rem;
  border-radius: 0.43rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0.6rem auto;
}
</style>
<script>
import { getOrderCoupon, getOrderCouponTemp } from "@api/order";
import { dataFormatT } from "@utils";

export default {
  name: "CouponListWindow",
  props: {
    value: Boolean,
    checked: Number,
    price: {
      type: [Number, String],
      default: undefined,
    },
    cartid: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 0,
    },
    isTempLink: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      couponList: [],
      loaded: false,
      cartids: this.cartid,
    };
  },
  watch: {
    price(n) {
      if (n === undefined || n == null) return;
      this.getCoupon();
    },
    cartid(n) {
      if (n === undefined || n == null) return;
      this.cartids = n;
      this.getCoupon();
    },
  },
  mounted: function () {
    this.getCoupon();
  },
  methods: {
    dataFormatT,
    close: function () {
      this.$emit("input", false);
      this.$emit("close");
    },
    getCoupon() {
      let type = this.type;
      let totalPrice = this.isTempLink
        ? ((this.$route && this.$route.query && this.$route.query.price) || this.price)
        : this.price;
      let coachId = this.isTempLink
        ? (this.$route && this.$route.query && this.$route.query.productId)
        : undefined;
      if (!this.cartids || (this.isTempLink && totalPrice === undefined)) {
        this.couponList = [];
        this.loaded = true;
        return;
      }
      if (this.isTempLink) {
        getOrderCouponTemp(this.cartids, type, totalPrice, coachId).then((res) => {
          this.couponList = res.data;
          this.loaded = true;
        });
      } else {
        getOrderCoupon(this.cartids, 0).then((res) => {
          this.couponList = res.data;
          this.loaded = true;
        });
      }
    },
    click(coupon) {
      this.$emit("checked", coupon);
      this.$emit("input", false);
    },
    couponNo: function () {
      this.$emit("checked", null);
      this.$emit("input", false);
    },
  },
};
</script>
